// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IVendorDto
 */
export interface IVendorDto {
    /**
     * 
     * @type {number}
     * @memberof IVendorDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IVendorDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IVendorDto
     */
    vendor_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendorDto
     */
    address_line1?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendorDto
     */
    address_line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendorDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendorDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendorDto
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendorDto
     */
    check_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendorDto
     */
    check_memo?: string;
}

/**
 * Check if a given object implements the IVendorDto interface.
 */
export function instanceOfIVendorDto(value: object): value is IVendorDto {
    return true;
}

export function IVendorDtoFromJSON(json: any): IVendorDto {
    return IVendorDtoFromJSONTyped(json, false);
}

export function IVendorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IVendorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'vendor_name': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'address_line1': json['address_line1'] == null ? undefined : json['address_line1'],
        'address_line2': json['address_line2'] == null ? undefined : json['address_line2'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'check_name': json['check_name'] == null ? undefined : json['check_name'],
        'check_memo': json['check_memo'] == null ? undefined : json['check_memo'],
    };
}

export function IVendorDtoToJSON(json: any): IVendorDto {
    return IVendorDtoToJSONTyped(json, false);
}

export function IVendorDtoToJSONTyped(value?: IVendorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account_id': value['account_id'],
        'vendor_name': value['vendor_name'],
        'address_line1': value['address_line1'],
        'address_line2': value['address_line2'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'check_name': value['check_name'],
        'check_memo': value['check_memo'],
    };
}

